export const localStorageStaticKeys = {
    LS_UNALTERED_DATA: "unalteredData",
    LS_ALTERED_DATA: "alteredData",
    LS_ERD_DATA: "erdData",
    LS_ERD_DATA_VERSIONS: "erdDataVersions",
    LS_TABLE_COORDINATES: "tableCoordinates",
    LS_ZOOM_AND_PAN_LEVEL: "zoomAndPanLevel"
};

export const tableHeaderHeight = 55.24;

export const tableColumnHeight = 45.22;

export const tableBackgroundShadowHeight = 28.86;

export const tableBackgroundBoxHeight = 118;

// table background shadow attribute Y axis
export const tbsTranslateAttrY = 118;

export const editTableColumnTypes = {
    ADD_COLUMN: "addColumn",
    DELETE_COLUMN: "deleteColumn"
};

export const erdTableMetaDataKeys = {
    // table property keys
    TABLE_ID: `tableId`,
    TABLE_NAME: `tableName`,
    TABLE_PATH: `tablePath`,
    UPDATED_TABLE_PATH: `updatedTablePath`,
    TABLE_COLUMNS_COUNT: `tableColumnsCount`,
    TABLE_COLUMNS: `tableColumns`,

    // column property keys
    COLUMN_ID: `columnId`,
    COLUMN_NAME: `columnName`,
    COLUMN_PATH: `columnPath`,
    UPDATED_COLUMN_PATH: `updatedColumnPath`,
    IS_COLUMN_PRIMARY_KEY: "isColumnPrimarykey",
    IS_COLUMN_FOREIGN_KEY: "isColumnForeignkey",
    FK_PK_RELATION_COLUMN_ID: `fkPkRelationColumnId`,
    COLUMN_DATA_TYPE: `columnDataType`
};

export const erdLinkMetaDataKeys = {
    LINK_ID: `linkId`,
    IS_LINK_ACTIVE: `isLinkActive`,
    SOURCE: `source`,
    TARGET: `target`
};

export const erdCrudFormKeys = {
    // edit, delete common keys
    TABLE_NAME_VALUE: `tableNameValue`,
    COLUMN_NAME_VALUE: `columnNameValue`,
    COLUMN_DATA_TYPE_VALUE: `columnDataTypeValue`,
    COLUMN_KEY_TYPE_VALUE: `columnKeyTypeValue`,
    COLUMN_FK_PK_RELATION_COLUMN_ID_VALUE: `columnFkPkRelationColumnIdValue`
};

export const tableKeyTypes = {
    PRIMARY_KEY: `pk`,
    FOREIGN_KEY: `fk`
};

export const erdCrudFormErrorKeys = {
    // edit, delete common keys
    ADD_NEW_COLUMN_ERROR: `addNewColumnError`,
    FK_PK_RELATION_COLUMN_ERROR: `fkPkRelationColumnError`
};

export const columnValueDataTypes = {
    INTEGER: "int32",
    TEXT: "string",
    BOOLEAN: "bool",
    FLOAT: "float"
};

export const erdModificationTypes = {
    EDIT_TABLE: "editTable",
    DELETE_TABLE: "deleteTable",
    ADD_TABLE: "addTable"
};

export const initialEmptyTableErdData = {
    [erdTableMetaDataKeys.TABLE_ID]: 0,
    [erdTableMetaDataKeys.TABLE_NAME]: `new_table`,
    [erdTableMetaDataKeys.TABLE_PATH]: `$.new_table`,
    [erdTableMetaDataKeys.TABLE_COLUMNS_COUNT]: ``,
    [erdTableMetaDataKeys.TABLE_COLUMNS]: [
        {
            [erdTableMetaDataKeys.COLUMN_ID]: `0-1`,
            [erdTableMetaDataKeys.COLUMN_NAME]: `id`,
            [erdTableMetaDataKeys.IS_COLUMN_PRIMARY_KEY]: true,
            [erdTableMetaDataKeys.IS_COLUMN_FOREIGN_KEY]: false,
            [erdTableMetaDataKeys.COLUMN_DATA_TYPE]: columnValueDataTypes.INTEGER
        }
    ]
};

export const erdMetaDataParentKeys = {
    TABLES: `tables`,
    LINKS: `links`
};

export const dashboardViewKeys = {
    CODE_VIEW: `codeView`,
    JSON_VIEW: `jsonView`,
    ERD_VIEW: `erdView`,
    PROTOBUF_VIEW: `protobufView`,
    SQL_VIEW: `sqlView`       // changed  //added for sql view
};

export const protobufTypes = {
    PROTOBUF_V3: "protobufV3",
    FDB_PROTOBUF: "fdbProtobuf"
};

// create empty erd data
export const emptyErdData = {
    [erdMetaDataParentKeys.TABLES]: [],
    [erdMetaDataParentKeys.LINKS]: []
};
